import { useGetApplication } from 'app/hooks';

import { default as catalogService, default as catalogservice } from '../../Catalog.service';
import { type CatalogTypeModel } from '../../CatalogType/models/types';
import type { CatalogValue } from '../models/catalogValue.model';

export const useCatalogList = (
  type: string,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  params: any = {},
  ignoreDefaultLang?: boolean
) => {
  const response = useGetApplication<Array<CatalogValue>>({
    url: catalogservice.baseCatalogUrl() + '/' + type,
    params,
    headers: ignoreDefaultLang ? { lang: true } : undefined
  });

  return response;
};

export const useCatalogListByParent = (
  type: string,
  parent: string,
  onLoad = true,
  ignoreDefaultLang?: boolean
) => {
  const response = useGetApplication<Array<CatalogValue>>(
    {
      url: catalogservice.baseCatalogUrl() + '/' + type,
      params: { parent: parent },
      headers: ignoreDefaultLang ? { lang: true } : undefined
    },
    onLoad
  );

  return response;
};

export const useCatalogByParent = (parentId: string) => {
  const response = useGetApplication<Array<CatalogValue>>({
    url: catalogservice.baseCatalogUrl() + '/parent/' + parentId,
    params: undefined
  });

  return response;
};

export const useCatalogTypeListAll = () => {
  return useGetApplication<Array<CatalogTypeModel>>({
    url: catalogService.baseCatalogTypeUrl() + '/all',
    params: {}
  });
};
